module.exports = __webpack_public_path__ + "static/media/nuotata.794bb728.jpeg";